import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Mail, Check, ArrowRight, Sparkles } from 'lucide-react';
interface EmailCaptureProps {
  profileColor: string;
}
export function EmailCapture({
  profileColor
}: EmailCaptureProps) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    setTimeout(() => {
      setStatus('success');
    }, 1500);
  };
  if (status === 'success') {
    return <div className="bg-[#111318] border border-[#E10600]/30 rounded-md p-8 text-center animate-in fade-in zoom-in duration-300 shadow-[0_0_30px_rgba(225,6,0,0.1)]" data-id="element-18">
        <div className="w-14 h-14 bg-[#E10600]/10 text-[#E10600] rounded-full flex items-center justify-center mx-auto mb-4 border border-[#E10600]/30" data-id="element-19">
          <Check size={28} data-id="element-20" />
        </div>
        <h3 className="text-2xl font-display font-bold text-white mb-2 uppercase tracking-wide" data-id="element-21">
          YOU'RE IN
        </h3>
        <p className="text-[#9ca3af]" data-id="element-22">
          Check your inbox for your full playbook and coaching access.
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="max-w-sm mx-auto" data-id="element-23">
      <div className="relative mb-4" data-id="element-24">
        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none" data-id="element-25">
          <Mail className="h-4 w-4 text-[#6B7280]" data-id="element-26" />
        </div>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email address" className="block w-full pl-10 pr-3 py-4 border border-[#2a2f3b] rounded-md bg-[#0B0F14] text-white placeholder-[#4b5563] focus:outline-none focus:bg-[#1a1f2b] focus:ring-1 focus:ring-[#E10600] focus:border-[#E10600] transition text-lg tracking-wide" required data-id="element-27" />
      </div>
      <Button type="submit" fullWidth size="lg" disabled={status === 'loading'} className="group" data-id="element-28">
        {status === 'loading' ? <span className="flex items-center" data-id="element-29">
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" data-id="element-30">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-31" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" data-id="element-32" />
            </svg>
            SENDING...
          </span> : <>
            GET MY FULL PLAYBOOK
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-33" />
          </>}
      </Button>
      <p className="text-[10px] text-[#4b5563] text-center mt-3" data-id="element-34">
        Free with your trial. No spam, ever.
      </p>
    </form>;
}